import Footer from './footer';
import Header from './navbar'
const Master = ({children}) => {
    return (
        <>
            <Header />
            {children}
            <Footer></Footer>
        </>
    )
}
export default Master;